export const getSubscriberInfo = (subscriberNumber, selfcarePage) => {
  if (!subscriberNumber || !selfcarePage?.subscribersByProduct?.Cellular) {
    return { subscriberNumber, firstName: '', lastName: '', fullName: '' };
  }

  const normalize = (v) => (v ? String(v).replace(/\D/g, '').trim() : '');
  const targetNorm = normalize(subscriberNumber);

  const subscriber = selfcarePage.subscribersByProduct.Cellular.find(s => 
    normalize(s.productSubscriberNo) === targetNorm
  );

  if (!subscriber) {
    return { subscriberNumber, firstName: '', lastName: '', fullName: subscriberNumber };
  }

  const firstName = (subscriber.productFirstName || '').trim();
  const lastName = (subscriber.productLastName || '').trim();
  const fullName = `${firstName} ${lastName}`.trim();

  return {
    subscriberNumber,
    firstName,
    lastName,
    fullName,
  };
};

export const enrichSubscriberSelection = (subscriberNumber, selfcarePage) => {
  const info = getSubscriberInfo(subscriberNumber, selfcarePage);
  return {
    ...info,
    // Backward compatibility - can still be used as string
    toString: () => subscriberNumber,
    valueOf: () => subscriberNumber
  };
};